export default __webpack_public_path__ + "static/media/language.c004527e.svg";